import React from 'react'

import Line from './SeparationLine.style'

const SeparationLine = () => {
  return <Line></Line>
}

export default SeparationLine
